/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Icon4IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Icon4Icon(props: Icon4IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 28 28"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <mask
        id={"a"}
        width={"28"}
        height={"28"}
        x={"0"}
        y={"0"}
        maskUnits={"userSpaceOnUse"}
        style={{
          maskType: 'alpha"'
        }}
      >
        <path fill={"#D9D9D9"} d={"M0 0h28v28H0z"}></path>
      </mask>

      <g mask={"url(#a)"}>
        <path
          fill={"#6D28D9"}
          d={
            "M10.281 25.51 8.2 22l-3.953-.866.386-4.07L1.953 14l2.679-3.065-.386-4.07L8.199 6l2.082-3.509 3.72 1.58 3.72-1.58L19.803 6l3.953.866-.386 4.07L26.05 14l-2.679 3.064.386 4.07-3.953.866-2.082 3.51L14 23.93zm.745-2.235 2.975-1.261 3.01 1.26 1.657-2.8 3.208-.735-.292-3.29L23.743 14l-2.159-2.485.292-3.29-3.208-.7-1.692-2.8-2.975 1.262-3.01-1.261-1.657 2.8-3.208.7.292 3.289L4.259 14l2.159 2.45-.292 3.325 3.208.7zm1.75-5.538 6.188-6.187-1.23-1.266-4.958 4.959-2.508-2.473L9.038 14z"
          }
        ></path>
      </g>
    </svg>
  );
}

export default Icon4Icon;
/* prettier-ignore-end */
